var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.$route.meta.header)?_c('CHeader'):_vm._e(),(_vm.$route.meta.leftNav)?_c('LeftNav'):_vm._e(),_c('router-view',{style:(_vm.style)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }